export default __webpack_public_path__ + "static/media/2.eec34033.jpg";